import React from 'react';
import classes from './FaqAccordion.module.scss';
import A from 'components/atoms/A/A';
import Collapsible from 'components/atoms/Collapsible/Collapsible';
import LinkIcon from './link.svg';
import { useRouter } from 'next/router';
import Heading from 'components/atoms/Heading/Heading';

interface Question {
  key?: string;
  question: string;
  answer: React.ReactNode;
}

export interface Props {
  heading?: string;
  questions: Question[];
  id?: string;
}

const FaqAccordion: React.FC<Props> = ({ heading, questions, id }) => {
  const router = useRouter();

  return (
    <section className={classes.root}>
      {heading && (
        <div id={id} className={classes.sectionHeading}>
          <Heading level={2} className={classes.sectionHeadingText}>
            {heading}
          </Heading>
          <A href={`${router.pathname}#${id}`}>
            <LinkIcon className={classes.largeLinkIcon} />
          </A>
        </div>
      )}
      {questions.map((Item) => {
        const { key, question, answer } = Item;
        return (
          <Collapsible
            itemScope
            itemProp="mainEntry"
            itemType="https://schema.org/Question"
            className={classes.collapsible}
            key={key || question}
            title={question}
            openTitle={question}
            closedTitle={question}
            headerClassName={classes.questionHeader}
          >
            <div
              className={classes.answer}
              itemScope
              itemProp="acceptedAnswer"
              itemType="https://schema.org/Answer"
            >
              {answer}
            </div>
          </Collapsible>
        );
      })}
    </section>
  );
};

export default FaqAccordion;
